/*******************************************************************************
 * Copyright (c) 2019-2022 Singularity AI, Inc. - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 ******************************************************************************/

import { all as en } from './en';
import { all as zh } from './zh';
import { all as names } from './commonNames';

/* Constants for strings */
export const c = names

/* Dictionary */
export const DICTIONARY: {
  [languageName: string]: {
    [commonName: string]: string
  }
} = {
  zh: zh,
  en: en,
}

export let language: keyof typeof DICTIONARY = window.localStorage.getItem('aws_language') || 'zh';

export const saTranslate = (str: string): string => {
  return DICTIONARY[language][str]
};

type languageType = "zh" | "en";

export const newSaTranslate = (language: languageType, str: string): string => {
  return DICTIONARY[language][str]
}
